import Nullstack from 'nullstack';
export default function IconTextSize({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-text-size",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 7v-2h13v2"
  }), "   ", Nullstack.element("path", {
    d: "M10 5v14"
  }), "   ", Nullstack.element("path", {
    d: "M12 19h-4"
  }), "   ", Nullstack.element("path", {
    d: "M15 13v-1h6v1"
  }), "   ", Nullstack.element("path", {
    d: "M18 12v7"
  }), "   ", Nullstack.element("path", {
    d: "M17 19h2"
  }), " ");
}